import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Aboutpage.css';
import { assets } from '../../assets/assets';
import { getImageUrl } from '../../utils/imageUtils';

const AboutPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [aboutInfo, setAboutInfo] = useState({
    storyTitle: 'OUR STORY',
    foundedYear: '',
    storyCompanyName: '',
    storyDescription: '',
    expertise: '',
    brands: [],
    approachTitle: 'OUR APPROACH',
    approachCompanyName: '',
    philosophy: '',
    services: '',
    heroImage: null
  });
  const [aboutImagePreview, setAboutImagePreview] = useState(null);
  const [error, setError] = useState('');
  
  const baseURL = window.APP_CONFIG?.API_URL || "https://backendweb.properteck.lk";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const aboutResponse = await axios.get(`${baseURL}/api/about/getabout`);
      if (aboutResponse.data.success && aboutResponse.data.data) {
        const data = aboutResponse.data.data;
        const formattedData = {
          storyTitle: data.ourStory?.title || 'OUR STORY',
          foundedYear: data.ourStory?.foundedYear || '',
          storyCompanyName: data.ourStory?.companyName || '',
          storyDescription: data.ourStory?.description || '',
          expertise: data.ourStory?.expertise || '',
          brands: data.ourStory?.brands || [],
          approachTitle: data.ourApproach?.title || 'OUR APPROACH',
          approachCompanyName: data.ourApproach?.companyName || '',
          philosophy: data.ourApproach?.philosophy || '',
          services: data.ourApproach?.services || '',
          heroImage: null
        };
        
        setAboutInfo(formattedData);
        if (data.heroImage) {
          setAboutImagePreview(getImageUrl(data.heroImage));
        }
      } else {
        setError('No data found');
      }
    } catch (error) {
      console.error('Error fetching about info:', error);
      setError('Failed to load about information');
    } finally {
      setIsLoading(false);
    }
  };

  // Using utility function from imageUtils

  return (
    <div className="about-container">
      <div className="about-wrapper">
        {/* About Section Header */}
        <h1 className="about-title">ABOUT {aboutInfo.storyCompanyName || 'PROPERTECK'}</h1>
        
        {/* Loading State */}
        {isLoading ? (
          <div className="about-loading-state">
            <div className="about-spinner"></div>
            <p>Loading data...</p>
          </div>
        ) : error ? (
          <div className="about-error">
            <p>{error}</p>
          </div>
        ) : (
          <div className="about-content-grid">
            {/* Company Image */}
            <div className="about-image-container">
              <img 
                src={aboutImagePreview || assets.background} 
                alt={`${aboutInfo.storyCompanyName || 'PROPERTECK'} Store`} 
                className="about-image" 
              />
            </div>
            
            {/* Company Description */}
            <div className="about-description">
              <div className="about-card">
                <h2 className="section-title">{aboutInfo.storyTitle}</h2>
                <p className="about-text">
                  Founded in {aboutInfo.foundedYear || '2015'}, <strong>{aboutInfo.storyCompanyName || 'PROPERTECK'}</strong> {aboutInfo.storyDescription || 'is one of Sri Lanka\'s leading computer retailers, specializing in high-performance computers, gaming setups, and professional workstations.'}
                </p>
                <p className="about-text">
                  {aboutInfo.expertise || 'Our expert team, with over 10 years of experience, is dedicated to helping customers find the perfect laptop, desktop, or accessories for their needs.'}
                  {aboutInfo.brands?.length > 0 && (
                    <> We stock the latest from top brands like {aboutInfo.brands.join(', ')}.</>
                  )}
                </p>
              </div>
            </div>
            
            {/* Vision and Mission */}
            <div className="about-philosophy">
              <div className="about-card">
                <h2 className="section-title">{aboutInfo.approachTitle}</h2>
                <p className="about-text">
                  At <strong>{aboutInfo.approachCompanyName || 'PROPERTECK'}</strong>, {aboutInfo.philosophy || 'we believe in delivering not just products but complete solutions.'}
                </p>
                <p className="about-text">
                  {aboutInfo.services || 'Visit our store to explore our extensive collection of laptops, desktops, gaming accessories, and networking solutions.'}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AboutPage;